import DownloadCircle from "assets/images/icon/download-circle"

export const reportsColumns = () => {
    return [
        {
            headerName: "Name",
            key: "name",
            renderValue: (row)=> {
                return <span style={{ color: '#E7730A' }}>{row?.name}</span>
            }
        },
        {
            headerName: "Description",
            key: "description"
        },
    ]
}

export const authorizationDocsColumns = () => {
    return [
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Label",
            key: "label"
        },
        {
            headerName: "Year",
            key: "year"
        },
        {
            headerName: "Field On",
            key: "field_on"
        },
        {
            headerName: "",
            key: "action_field",
            renderValue: () => {
                return (
                    <div>
                        <DownloadCircle />
                    </div>
                )
            }
        },
    ]
}

export const companyDocsColumns = () => {
    return [
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Label",
            key: "label"
        },
        {
            headerName: "Year",
            key: "year"
        },
        {
            headerName: "Field On",
            key: "field_on"
        },
        {
            headerName: "",
            key: "action_field",
            renderValue: () => {
                return (
                    <div>
                        <DownloadCircle />
                    </div>
                )
            }
        },
    ]
}

export const employeeDocsColumns = () => {
    return [
        {
            headerName: "Employee",
            key: "employee"
        },
        {
            headerName: "Label",
            key: "label"
        },
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Year",
            key: "year"
        },
        {
            headerName: "Field On",
            key: "field_on"
        },
        {
            headerName: "",
            key: "action_field",
            renderValue: () => {
                return (
                    <div>
                        <DownloadCircle />
                    </div>
                )
            }
        },
    ]
}

export const contractorDocsColumns = () => {
    return [
        {
            headerName: "Employee",
            key: "employee"
        },
        {
            headerName: "Label",
            key: "label"
        },
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Jurisdiction",
            key: "jurisdiction"
        },
        {
            headerName: "Year",
            key: "year"
        },
        {
            headerName: "Field On",
            key: "field_on"
        },
        {
            headerName: "",
            key: "action_field",
            renderValue: () => {
                return (
                    <div>
                        <DownloadCircle />
                    </div>
                )
            }
        },
    ]
}